import { toast } from "react-toastify";
import formErrorsHandler from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetWorkersList,
    requestGetWorkerFullById,
    requestInsertWorker,
    requestUpdateWorker,

    requestGetPayRateOverrides,
    requestGetPayRateOverrideSingle,
    requestCreatePayRateOverrideSingle,
    requestUpdatePayRateOverrideSingle,
    requestDeletePayRateOverrideSingle,

    requestGetComments,
    requestGetComment,
    requestCreateComment,
    requestUpdateComment,
    requestDeleteComment,
    requestResetPassword
} from "api/menu/master-files/workers-maintenance/requests";

import {
    setEmployee,
} from "actions/employeeActions";

export const WORKERS_LOADING = "WORKERS_LOADING";
export const WORKERS_ERROR = "WORKERS_ERROR";

export const WORKERS_GET_LIST = "WORKERS_GET_LIST";
export const WORKERS_GET_BY_ID = "WORKERS_GET_BY_ID";
export const WORKERS_INSERT_BY_ID = "WORKERS_INSERT_BY_ID";
export const WORKERS_UPDATE_BY_ID = "WORKERS_UPDATE_BY_ID";

export const WORKERS_GET_PAYRATE_OVERRIDES = "WORKERS_GET_PAYRATE_OVERRIDES";
export const WORKERS_GET_PAYRATE_OVERRIDE_SINGLE = "WORKERS_GET_PAYRATE_OVERRIDE_SINGLE";
export const WORKERS_UPDATE_PAYRATE_OVERRIDE_SINGLE = "WORKERS_UPDATE_PAYRATE_OVERRIDE_SINGLE";
export const WORKERS_DELETE_PAYRATE_OVERRIDE_SINGLE = "WORKERS_DELETE_PAYRATE_OVERRIDE_SINGLE";

export const WORKERS_GET_COMMENTS = "WORKERS_GET_COMMENTS";
export const WORKERS_GET_COMMENT_SINGLE = "WORKERS_GET_COMMENT_SINGLE";
export const WORKERS_UPDATE_COMMENT_SINGLE = "WORKERS_UPDATE_COMMENT_SINGLE";
export const WORKERS_DELETE_COMMENT_SINGLE = "WORKERS_DELETE_COMMENT_SINGLE";

export const setLoading = (status) => ({
    type: WORKERS_LOADING,
    payload: status
});

export const getWorkersList = () => dispatch => {
    dispatch(setLoading(true));
    requestGetWorkersList()
        .then(response => {
            dispatch({
                type: WORKERS_GET_LIST,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, WORKERS_ERROR));
        });
};

export const getWorkerFullById = (id) => dispatch => {
    dispatch(setLoading(true));
    requestGetWorkerFullById(id)
        .then(response => {
            dispatch(setEmployee(response.data));
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, WORKERS_ERROR));
        });
};

export const insertWorker = (data) => dispatch => {
    dispatch(setLoading(true));
    requestInsertWorker(data)
        .then(response => {
            dispatch({
                type: WORKERS_INSERT_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, WORKERS_ERROR));
        })
        .finally(() =>
            dispatch(setLoading(false)));
};

export const updateWorker = (id, data) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateWorker(id, data)
        .then(response => {
            dispatch({
                type: WORKERS_UPDATE_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, WORKERS_ERROR));
        });
};

/**
 * Get PayRate Overrides.
 * @param {Number} id - employeeId
 * @returns {function(...[*]=)}
 */
export const getPayRateOverrides = (id) => dispatch => {
    dispatch(setLoading(true));
    requestGetPayRateOverrides(id)
        .then(response => {
            dispatch({
                type: WORKERS_GET_PAYRATE_OVERRIDES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getPayRateOverrideSingle = (employeeId, payrateId) => dispatch => {
    if (!employeeId && !payrateId) {
        dispatch({
            type: WORKERS_GET_PAYRATE_OVERRIDE_SINGLE,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    requestGetPayRateOverrideSingle(employeeId, payrateId)
        .then(response => {
            dispatch({
                type: WORKERS_GET_PAYRATE_OVERRIDE_SINGLE,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const createPayRateOverrideSingle = (employeeId, data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestCreatePayRateOverrideSingle(employeeId, data)
        .then(response => {
            dispatch({
                type: WORKERS_UPDATE_PAYRATE_OVERRIDE_SINGLE,
                payload: response.data
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, WORKERS_ERROR));
        });
};

export const updatePayRateOverrideSingle =
    (employeeId, payrateId, data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestUpdatePayRateOverrideSingle(employeeId, payrateId, data)
        .then(response => {
            dispatch({
                type: WORKERS_UPDATE_PAYRATE_OVERRIDE_SINGLE,
                payload: response.data
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, WORKERS_ERROR));
        });
};

export const deletePayRateOverrideSingle = (employeeId, payrateId) => dispatch => {
    dispatch(setLoading(true));
    requestDeletePayRateOverrideSingle(employeeId, payrateId)
        .then(() => {
            dispatch({
                type: WORKERS_DELETE_PAYRATE_OVERRIDE_SINGLE,
                payload: payrateId
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getComments = (employeeId) => dispatch => {
    dispatch(setLoading(true));
    requestGetComments(employeeId)
        .then(response => {
            dispatch({
                type: WORKERS_GET_COMMENTS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getComment = (employeeId, commentId) => dispatch => {
    dispatch(setLoading(true));
    requestGetComment(employeeId, commentId)
        .then(response => {
            dispatch({
                type: WORKERS_GET_COMMENT_SINGLE,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const clearComment = () => dispatch => {
    dispatch({
        type: WORKERS_GET_COMMENT_SINGLE,
        payload: {}
    });
};

export const createComment = (employeeId, data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestCreateComment(employeeId, data)
        .then(response => {
            dispatch({
                type: WORKERS_UPDATE_COMMENT_SINGLE,
                payload: response.data
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateComment = (employeeId, commentId, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateComment(employeeId, commentId, data)
        .then(response => {
            dispatch({
                type: WORKERS_UPDATE_COMMENT_SINGLE,
                payload: response.data
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteComment = (employeeId, commentId) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteComment(employeeId, commentId)
        .then(() => {
            dispatch({
                type: WORKERS_DELETE_COMMENT_SINGLE,
                payload: commentId
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const resetPassword = (employeeId, password) => dispatch => {
    dispatch(setLoading(true));
    requestResetPassword(employeeId, password)
        .then(() => {
            toast("Password reseted successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};
